import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconFilter = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M15 11H2V13H15V11Z" }),
            React.createElement("path", { d: "M22 6H9V8H22V6Z" }),
            React.createElement("path", { d: "M22 16H9V18H22V16Z" }),
            React.createElement("path", { d: "M6 10H8V4H6V6H2V8H6V10Z" }),
            React.createElement("path", { d: "M6 16H2V18H6V20H8V14H6V16Z" }),
            React.createElement("path", { d: "M18 9H16V15H18V13H22V11H18V9Z" }))));
};
